import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface RoleBasedRedirectProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  redirectPath?: string;
}

const RoleBasedRedirect: React.FC<RoleBasedRedirectProps> = ({ 
  children, 
  requireAdmin = false,
  redirectPath = '/my-signatures'
}) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null; // ou um componente de loading
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se a página requer admin e o usuário não é admin, redireciona
  if (requireAdmin && !user?.isAdmin) {
    return <Navigate to={redirectPath} replace />;
  }

  // Permitir que todos os usuários autenticados acessem o dashboard
  // Se o usuário não é admin e está tentando acessar o dashboard, redireciona para minhas assinaturas
  // Comentado temporariamente para permitir acesso ao dashboard
  /*
  if (!user?.isAdmin && window.location.pathname === '/') {
    return <Navigate to="/my-signatures" replace />;
  }
  */

  return <>{children}</>;
};

export default RoleBasedRedirect;
